module.exports = __webpack_public_path__ + "static/media/sort_asc.0e5a74f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sort_asc.svg
// module id = 1051
// module chunks = 3